import axios from "axios";
import { apiEndPoint } from "./constants";
import { getUserAuth } from './helpers';
import { refreshToken, refreshAuth } from "../store/actions";
import { isString } from "lodash";

axios.defaults.baseURL = apiEndPoint;
axios.interceptors.request.use(req => {
  let userInfo = getUserAuth();
  req.headers = {
    ...req.headers,
    ...userInfo
  };
  req.headers["authentication"] = userInfo.token?.startsWith('bearer ') ? userInfo.token : `bearer ${userInfo.token}`
  req.headers.authorization = userInfo.authorization?.startsWith('bearer ') ? userInfo.authorization : `bearer ${userInfo.authorization}`;
  return req;
});

axios.interceptors.response.use(
  res => res,
  err => {
    let msg = err.response?.data?.message || err.response?.data
    if (msg && isString(msg) && msg.startsWith("<!")) {
      let getRes = err.response.data.match(/(?<=\<pre\>).+(?=\<\/pre\>)/);
      err.response.data = getRes[0];
    }
    if (err.response?.status === 404) {
      throw new Error(`${err.config.url} not found`);
    }
    else if (err.response?.status === 401) {
      refreshToken();
      refreshAuth();
    }
    throw err;
  }
);
